"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var TabsWrapper = /** @class */ (function (_super) {
    __extends(TabsWrapper, _super);
    function TabsWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabsWrapper.prototype.findTabLinks = function () {
        return this.findAll('.awsui-tabs-tab-link');
    };
    /**
     * Returns a tab link from the tab labels for a given index.
     *
     * @param index 1-based index of the tab link to return.
     */
    TabsWrapper.prototype.findTabLinkByIndex = function (index) {
        return this.find(".awsui-tabs-tab:nth-child(" + index + ") .awsui-tabs-tab-link");
    };
    TabsWrapper.prototype.findTabLinkById = function (id) {
        return this.find(".awsui-tabs-tab-link[data-testid=\"" + id + "\"]");
    };
    TabsWrapper.prototype.findActiveTab = function () {
        return this.find('.awsui-tabs-tab-active');
    };
    TabsWrapper.prototype.findTabContent = function () {
        return this.find('.awsui-tabs-content-active');
    };
    return TabsWrapper;
}(dom_1.ComponentWrapper));
exports.default = TabsWrapper;
//# sourceMappingURL=awsui-tabs.js.map